import staticRoutes from "./staticRoutes.json";
import applicationRoutes from "./applicationRoutes.json";
import englishRouteTranslations from "./staticRouteTranslations.json";

export const SITE_NAME = "Eternua";
export const SITE_URL = String(
  process.env.REACT_APP_SITE_URL || "https://www.eternua.com"
).replace(/\/+$/, "");

export const STATIC_ROUTES = staticRoutes;

const englishFallbackText = {
  "Météo | Eternua": "Weather | Eternua",
  "Consultez la météo et les prévisions pour la ville de votre choix.": "View the weather and forecast for your chosen city.",
  "Carte vivante | Eternua": "Live map | Eternua",
  "Découvrez les activités à proximité avec des positions approximatives.": "Discover nearby activities with approximate locations.",
  "Les 44 IA humaines | Eternua": "The 44 human AIs | Eternua",
  "Découvrez les noms, rôles et missions des 44 IA humaines d’Eternua.": "Discover the names, roles and missions of Eternua’s 44 human AIs.",
  "Référence Babysitting | Eternua": "Babysitting reference | Eternua",
  "Réponse privée et consentie à une demande de référence Babysitting.": "A private, consented response to a Babysitting reference request.",
  "Espace privé | Eternua": "Private space | Eternua",
  "Espace personnel protégé Eternua.": "Protected personal space on Eternua.",
  "Contenu public | Eternua": "Public content | Eternua",
  "Consultez ce contenu public sur Eternua.": "View this public content on Eternua.",
  "Mon panier | Eternua": "My basket | Eternua",
  "Mes retours | Eternua": "My returns | Eternua",
  "Ventes flash | Eternua": "Flash sales | Eternua",
  "Jeux | Eternua": "Games | Eternua",
  "Serveurs Rexuiz | Eternua": "Rexuiz servers | Eternua",
  "Musique | Eternua": "Music | Eternua",
  "Mes relations | Eternua": "My connections | Eternua",
  "Les espaces Eternua | Eternua": "Eternua spaces | Eternua",
  "Conditions Premium | Eternua": "Premium terms | Eternua",
  "Aide d’urgence | Eternua": "Emergency help | Eternua",
  "Découvrez cet espace sur Eternua.": "Discover this space on Eternua.",
  "Page introuvable | Eternua": "Page not found | Eternua",
  "Cette page n’existe pas ou n’est plus disponible.": "This page does not exist or is no longer available."
};

const PRIVATE_PATH_PATTERNS = [
  /^\/premium\/(?:succes|annule|confirmation)\/?$/,
  /^\/(?:market\/immobilier\/paiements-test\/[^/]+|market\/animaux\/adoption\/paiements-test\/[^/]+|sport\/locations-test\/[^/]+|crowdfunding\/paiements-test\/[^/]+|soutenir-eternua\/test)\/?$/,
  /^\/(?:organiser|souvenirs)(?:\/|$)/,
  /^\/premium\/(?:espaces|tableau-de-bord|outils|quotidien|studio|selection|foyer|favoris|partenaires)(?:\/|$)/,
  /^\/entraide(?:\/|$)/,
  /^\/(?:login|register|verify-email|forgot-password|reset-password|mfa-setup|onboarding|bienvenue|continuer)(?:\/|$)/,
  /^\/profil\/?$/,
  /^\/profil\/rubrique(?:\/|$)/,
  /^\/mon-profil(?:\/|$)/,
  /^\/(?:passeport-confiance|confiance-confidentialite)(?:\/|$)/,
  /^\/(?:chat|video|live)(?:\/|$)/,
  /^\/(?:mes-eternua|mes-demarches|mes-contenus|publier|vendre|mon-bilan|mon-week-end|mon-parcours|mon-infini|studio-lia)(?:\/|$)/,
  /^\/(?:portefeuille|wallet|mon-abonnement|kyc)(?:\/|$)/,
  /^\/(?:amis|annonces|notifications|parrainage)(?:\/|$)/,
  /^\/(?:admin|moderation|finances-desactivees)(?:\/|$)/,
  /^\/recherche(?:\/|$)/,
  /^\/forum\/(?:profil|rang|categories\/[^/]+\/nouveau)(?:\/|$)/,
  /^\/crowdfunding\/(?:mes-projets|nouveau|createur|dashboard)(?:\/|$)/,
  /^\/crowdfunding\/projets\/[^/]+\/editer(?:\/|$)/,
  /^\/market\/(?:vendre|encheres|babysitting)(?:\/|$)/,
  /^\/market\/immobilier\/(?:favoris|publier|reservations|espace-hote|espace)(?:\/|$)/,
  /^\/cercles-du-jour\/nouveau(?:\/|$)/,
  /^\/voyage\/covoiturage\/(?:publier|mes-trajets|mes-reservations|paiements|reservations)(?:\/|$)/,
  /^\/recompenses(?:\/|$)/,
  /^\/(?:communaute|groupes|cercles|projets)(?:\/|$)/,
];

const DYNAMIC_PUBLIC_PATTERNS = [
  /^\/forum\/(?:categories|sujets)\/[^/]+(?:\/|$)/,
  /^\/crowdfunding\/projets\/[^/]+(?:\/|$)/,
  /^\/market\/immobilier\/annonces\/[^/]+(?:\/|$)/,
  /^\/market\/animaux\/adoption\/[^/]+\/[^/]+(?:\/|$)/,
  /^\/profil\/[^/]+(?:\/annonces)?(?:\/|$)/,
  /^\/voyage\/covoiturage\/trajets\/[^/]+(?:\/|$)/,
  /^\/annonce\/\d+(?:-[^/]+)?(?:\/|$)/,
  /^\/enchere\/[0-9a-f-]+(?:-[^/]+)?(?:\/|$)/i,
  /^\/emploi\/offre\/[0-9a-f-]+(?:-[^/]+)?(?:\/|$)/i,
  /^\/services\/[0-9a-f-]+(?:-[^/]+)?(?:\/|$)/i,
  /^\/evenements\/[^/]+(?:\/|$)/,
];

const APPLICATION_PATH_PATTERNS = applicationRoutes.map((routePath) => {
    const segments = routePath.split("/").map((segment) => {
      if (segment === "*") return ".*";
      if (segment.startsWith(":")) return "[^/]+";
      return segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    });
    const expression = routePath.endsWith("/*")
      ? `${segments.slice(0, -1).join("/")}(?:/.*)?`
      : segments.join("/");
    return new RegExp(`^${expression}/?$`);
  });

export function normalizePathname(pathname = "/") {
  const value = `/${String(pathname || "/").replace(/^\/+|\/+$/g, "")}`;
  return value === "//" ? "/" : value;
}

export function absoluteUrl(value = "/") {
  if (/^https?:\/\//i.test(String(value))) return String(value);
  return `${SITE_URL}${String(value).startsWith("/") ? value : `/${value}`}`;
}

export function isPrivatePath(pathname) {
  const path = normalizePathname(pathname);
  if (path === "/mon-infini/decouvrir") return false;
  return PRIVATE_PATH_PATTERNS.some((pattern) => pattern.test(path));
}

export function isDynamicPublicPath(pathname) {
  const path = normalizePathname(pathname);
  return DYNAMIC_PUBLIC_PATTERNS.some((pattern) => pattern.test(path));
}

export function findStaticRoute(pathname, lang = "fr") {
  const path = normalizePathname(pathname);
  const route = STATIC_ROUTES.find((item) => item.path === path);
  return route ? { ...route, ...(lang === "en" ? englishRouteTranslations[path] : {}) } : null;
}

export function resolveRouteSeo(pathname, search = "", lang = "fr") {
  const meta = resolveSourceRouteSeo(pathname, search, lang);
  if (lang !== "en") return { ...meta, lang };
  const translated = (value) => englishFallbackText[value] || value;
  return { ...meta, title: translated(meta.title), description: translated(meta.description), imageAlt: translated(meta.imageAlt), lang };
}

function resolveSourceRouteSeo(pathname, search, lang) {
  const path = normalizePathname(pathname);
  const route = findStaticRoute(path, lang);
  const privatePath = isPrivatePath(path) || route?.indexable === false;
  const hasQuery = Boolean(String(search || "").replace(/^\?/, ""));

  // These existing pages are readable in preview but keep their current noindex policy.
  const previewTitles = {
    "/meteo": ["Météo", "Consultez la météo et les prévisions pour la ville de votre choix."],
    "/carte-vivante": ["Carte vivante", "Découvrez les activités à proximité avec des positions approximatives."],
    "/ia-humaines": ["Les 44 IA humaines", "Découvrez les noms, rôles et missions des 44 IA humaines d’Eternua."],
  };
  if (previewTitles[path]) {
    const [title, description] = previewTitles[path];
    return {
      path,
      title: `${title} | ${SITE_NAME}`,
      description,
      canonical: absoluteUrl(path),
      indexable: false,
      shareable: false,
      robots: "noindex, nofollow, noarchive",
    };
  }

  if (path === "/babysitting/reference") {
    return {
      path,
      title: `Référence Babysitting | ${SITE_NAME}`,
      description: "Réponse privée et consentie à une demande de référence Babysitting.",
      canonical: null,
      indexable: false,
      shareable: false,
      robots: "noindex, nofollow, noarchive",
      sensitive: true,
    };
  }

  if (route) {
    const indexable = !privatePath && !hasQuery;
    return {
      ...route,
      canonical: absoluteUrl(route.path),
      indexable,
      shareable: !privatePath,
      sensitive: privatePath,
      robots: privatePath
        ? "noindex, nofollow, noarchive"
        : indexable
          ? "index, follow, max-image-preview:large"
          : "noindex, follow",
    };
  }

  if (privatePath) {
    return {
      path,
      title: `Espace privé | ${SITE_NAME}`,
      description: "Espace personnel protégé Eternua.",
      canonical: absoluteUrl(path),
      indexable: false,
      shareable: false,
      robots: "noindex, nofollow, noarchive",
      sensitive: true,
    };
  }

  if (isDynamicPublicPath(path)) {
    return {
      path,
      title: `Contenu public | ${SITE_NAME}`,
      description: "Consultez ce contenu public sur Eternua.",
      canonical: absoluteUrl(path),
      image: "/images/social/eternua-home.jpg",
      imageAlt: "Eternua",
      indexable: false,
      shareable: true,
      robots: "noindex, follow",
      pendingDynamicData: true,
    };
  }

  // Registered application screens are not missing pages. Preserve noindex
  // until they have dedicated metadata; only genuinely unknown paths use 404.
  const registered = APPLICATION_PATH_PATTERNS.some((pattern) => pattern.test(path));
  if (registered) {
    const titles = {
      "/market/panier": "Mon panier", "/market/retours": "Mes retours",
      "/market/flash": "Ventes flash", "/jeux": "Jeux",
      "/rexuiz/serveurs": "Serveurs Rexuiz", "/music": "Musique",
      "/relations": "Mes relations", "/acces": "Les espaces Eternua",
      "/cgv/premium": "Conditions Premium", "/aide-urgence": "Aide d’urgence",
    };
    return {
      path,
      title: titles[path] ? `${titles[path]} | ${SITE_NAME}` : SITE_NAME,
      description: "Découvrez cet espace sur Eternua.",
      canonical: null,
      indexable: false,
      shareable: false,
      robots: "noindex, nofollow, noarchive",
    };
  }

  return {
    path,
    title: `Page introuvable | ${SITE_NAME}`,
    description: "Cette page n’existe pas ou n’est plus disponible.",
    canonical: absoluteUrl(path),
    indexable: false,
    shareable: false,
    robots: "noindex, nofollow, noarchive",
    notFound: true,
  };
}

export function cleanSeoText(value, maxLength = 180) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, maxLength);
}

export const dynamicSeoTemplates = {
  listing: ({ title, category, description, image, imageAlt, indexable = true }) => ({
    title: `${cleanSeoText(title, 80)} – ${cleanSeoText(category, 40)} | Eternua`,
    description: cleanSeoText(description),
    image,
    imageAlt: cleanSeoText(imageAlt || title, 120),
    indexable,
  }),
  job: ({ title, city, description, image, indexable = true }) => ({
    title: `${cleanSeoText(title, 80)} in ${cleanSeoText(city, 50)} | Eternua Jobs`,
    description: cleanSeoText(description),
    image,
    imageAlt: cleanSeoText(title, 120),
    indexable,
  }),
  service: ({ name, place, description, image, indexable = true }) => ({
    title: `${cleanSeoText(name, 80)} in ${cleanSeoText(place, 50)} | Eternua`,
    description: cleanSeoText(description),
    image,
    imageAlt: cleanSeoText(name, 120),
    indexable,
  }),
  event: ({ name, date, description, image, indexable = true }) => ({
    title: `${cleanSeoText(name, 80)} – ${cleanSeoText(date, 40)} | Eternua`,
    description: cleanSeoText(description),
    image,
    imageAlt: cleanSeoText(name, 120),
    indexable,
  }),
  crowdfunding: ({ name, description, image, indexable = true }) => ({
    title: `${cleanSeoText(name, 90)} – Crowdfunding | Eternua`,
    description: cleanSeoText(description),
    image,
    imageAlt: cleanSeoText(name, 120),
    indexable,
  }),
};
